document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.js-video-autoplay');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const container = entry.target;

        const video = container.querySelector('video');
        const iframe = container.querySelector('iframe');

        if (entry.isIntersecting) {
          if (video) {
            video.muted = true;
            video.play();
          } else if (iframe) {
            const src = iframe.src;

            if (src.includes('youtube.com')) {
              // YouTube play
              iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            } else if (src.includes('vimeo.com')) {
              // Vimeo play
              iframe.contentWindow.postMessage('{"method":"play"}', '*');
            }
          }
        } else if (video) {
          video.pause();
        } else if (iframe) {
          const src = iframe.src;

          if (src.includes('youtube.com')) {
            // YouTube pause
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (src.includes('vimeo.com')) {
            // Vimeo pause
            iframe.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        }
      });
    },
    {
      threshold: 0.5
    }
  );

  containers.forEach((container) => {
    observer.observe(container);

    const video = container.querySelector('video');
    if (video) {
      video.addEventListener('click', () => {
        video.controls = true;
        video.muted = false;
        video.play();
      });
    }
  });
});
